function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 18.439C23.8913 18.4444 23.7825 18.4545 23.6737 18.4545C18.5502 18.4553 13.4266 18.4562 8.30297 18.4513C8.10844 18.4511 7.97162 18.5038 7.83281 18.6432C6.23607 20.2466 4.6326 21.8432 3.03053 23.4413C2.97199 23.4997 2.91 23.5547 2.8193 23.6396V18.439H0V3C0.0930469 3.00527 0.186152 3.01518 0.279199 3.01518C8.09309 3.01588 15.9069 3.01588 23.7207 3.01518C23.8138 3.01518 23.9069 3.00527 24 3V18.439Z",
  fill: "#333333"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2334 8.61134H19.7742V7.24487H4.2334V8.61134Z",
  fill: "white"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.2334 11.4181H19.7742V10.0527H4.2334V11.4181Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.22656 14.2254H14.1419V12.8594H4.22656V14.2254Z",
  fill: "white"
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 21,
  cy: 17,
  r: 7.5,
  fill: "#FFF3D9",
  stroke: "#333333"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.0253 16.9315C22.029 17.2034 21.9364 17.4238 21.7256 17.6138C20.8699 18.3854 20.0196 19.1622 19.1655 19.9353C18.9523 20.1283 18.8409 20.124 18.6254 19.9234C18.4376 19.7485 18.2511 19.5723 18.0673 19.3938C17.8713 19.2036 17.8735 19.1021 18.0816 18.9126C18.8228 18.2374 19.5631 17.5614 20.3107 16.8924C20.4326 16.7833 20.4783 16.6734 20.4775 16.5187C20.4713 15.3652 20.4736 14.2118 20.4745 13.0583C20.4747 12.7569 20.5422 12.695 20.8652 12.6934C21.123 12.6921 21.3809 12.692 21.6387 12.6934C21.9476 12.6952 22.0214 12.7606 22.0221 13.0415C22.0238 13.7018 22.0226 14.362 22.0226 15.0223C22.0226 15.6587 22.0169 16.2952 22.0253 16.9315Z",
  fill: "#333333"
});

var SvgQaPendingIcon = function SvgQaPendingIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 25,
    viewBox: "0 0 29 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQaPendingIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Q&A_pending_icon.35624abb.svg";
export { ForwardRef as ReactComponent };